import React, {useEffect} from 'react';
import '../../FieldSelectMenu.css';
import './GroundBackgroundSelectPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import FloatingBackButton from '../../elements/FloatingBackButton/FloatingBackButton';
import {MaskedIcon, MASKED_ICON_TONES} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {sendButtonClickEvent} from '../../../analytics/gameAnalytics';
import {checkIfKnownGroundBackground} from '../../../configs/groundBackgrounds';
import {
  GROUND_BACKGROUND_CHOICE_ORDER,
  GROUND_BACKGROUND_CHOICE_TEXT,
  GROUND_BACKGROUND_NAMES,
  RANDOM_GROUND_BACKGROUND_NAME,
  getGroundBackgroundPreview,
} from '../../../configs/groundBackgroundChoice';
import {GROUND_BACKGROUND_RANDOM_ICON_PATH} from '../../GroundBackgroundSelectButton/GroundBackgroundSelectButton';

const PAGE_ID = 'GroundBackgroundSelectPage';

// Случайная — первой: это выбор по умолчанию
const OPTIONS = [
  {id: null, name: RANDOM_GROUND_BACKGROUND_NAME},
  ...GROUND_BACKGROUND_CHOICE_ORDER.map((id) => ({id, name: GROUND_BACKGROUND_NAMES[id]})),
];

/**
 * Экран выбора подложки поля для локальной партии (игроку — «Выбор биома»):
 * плитки с маленькими картинками всех подложек и случайная. Нажатие на плитку выбирает ее —
 * что делать дальше (вернуться к настройке партии), решает страница-хозяин.
 *
 * Картинки — только превью (см. configs/groundBackgroundChoice): полные
 * подложки весят десятки мегабайт на всех.
 *
 * @param {string|null} value — нынешний выбор; null — случайная
 * @param {Function} onSelect — (идентификатор подложки | null) => void
 * @param {Function} onBack — уйти без выбора
 */
function GroundBackgroundSelectPage({value = null, onSelect, onBack}) {
  usePageAnalytics(PAGE_ID);

  // Экран открывается из середины длинной страницы настройки: без этого он
  // показался бы прокрученным к ее прежнему месту
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Выбор не из перечня (подложку сняли с раздачи) разыграют случайно — так
  // он и показан, как и на кнопке «Биом: …»
  const selectedId = checkIfKnownGroundBackground(value) ? value : null;

  const handleSelect = (id) => {
    sendButtonClickEvent(PAGE_ID, 'ground_background', id || 'random');
    MENU_SOUND_MANAGER.playMenuButtonClick();
    onSelect?.(id);
  };

  return (
    <>
      <FloatingBackButton onBack={onBack} pageId={PAGE_ID}/>
      <h1 className="menu-title field-select-menu_title">{GROUND_BACKGROUND_CHOICE_TEXT.pageTitle}</h1>

      <div className="ground-background-grid">
        {OPTIONS.map(({id, name}) => {
          const isSelected = id === selectedId;
          const preview = getGroundBackgroundPreview(id);

          return (
            <button
              key={id || 'random'}
              type="button"
              className={`ground-background-tile ${isSelected ? 'ground-background-tile_selected' : ''}`}
              onClick={() => handleSelect(id)}
              aria-pressed={isSelected}
              title={name}
              data-ground-background={id || 'random'}
            >
              <span className="ground-background-tile_picture">
                {preview
                  ? <img className="ground-background-tile_image" src={preview} alt="" decoding="async"/>
                  : (
                    <MaskedIcon
                      className="ground-background-tile_random-icon"
                      src={GROUND_BACKGROUND_RANDOM_ICON_PATH}
                      tone={MASKED_ICON_TONES.CONTROLS}
                    />
                  )}
                {isSelected && (
                  <img className="ground-background-tile_check" src="/img/icons/check.png" alt="Выбрано"/>
                )}
              </span>
              <span className="ground-background-tile_name">{name}</span>
            </button>
          );
        })}
      </div>

      <div className="main-menu-buttons">
        <PageButton className="main-menu-button" onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GroundBackgroundSelectPage;
